// Centralised site config
export const SITE = {
  name: "O.G. Marketing Digital",
  shortName: "O.G. Digital",
  whatsappNumber: "5548988177006", // international format, used by wa.me
  whatsappDisplay: "(48) 98817-7006",
  address: {
    line1: "Centro Empresarial Corporate Park",
    line2: "Florianópolis – SC",
    cep: "CEP 88050-001",
  },
  logo: "https://customer-assets.emergentagent.com/job_sites-vendas-google/artifacts/5l0b8lr2_ChatGPT_Image_12_de_jun._de_2026__13_13_52-removebg-preview.png",
  googlePartner:
    "https://customer-assets.emergentagent.com/job_ece91c2e-673d-4f55-b2e9-af75aa40972a/artifacts/ixbaejzo_google-partner.png",
};

export const waUrl = (msg = "Olá! Gostaria de solicitar um orçamento.") =>
  `https://wa.me/${SITE.whatsappNumber}?text=${encodeURIComponent(msg)}`;
